// This file is generated automatically by `scripts/build/fp.js`. Please, don't change it.
import fn from '../../formatISO/index.js';
import convertToFP from '../_lib/convertToFP/index.js';
var formatISO = convertToFP(fn, 1);
export default formatISO;


//////////////////
// WEBPACK FOOTER
// ./~/date-fns/esm/fp/formatISO/index.js
// module id = 877
// module chunks = 0